export default "__VITE_ASSET__CjgOApF7__"